import { useTexture } from "@react-three/drei";
import { RepeatWrapping } from "three";
import { TextureOptions } from "@/services/interfaces";
import { useDeferredValue } from "react";
import { config_base } from "@/data/config_base";

export default function useCopyTexture(texturePaths, { repeat, rotation, offset }: TextureOptions) {
	if (!texturePaths) return [];

	const deferredPaths = Object.entries(texturePaths).reduce((acc, [key, value]) => {
		acc[key] = useDeferredValue(value);
		return acc;
	}, {});

	const baseTextures = useTexture(deferredPaths);

	if (!Array.isArray(Object.values(baseTextures))) return [];

	return Object.entries(baseTextures).reduce((acc, [key, originalTexture], i) => {
		if (!originalTexture) return acc;

		const newTexture = originalTexture.clone();
		newTexture.wrapS = newTexture.wrapT = RepeatWrapping;

		if (repeat) {
			newTexture.repeat.set(repeat.x, repeat.y);
		}

		if (offset) {
			newTexture.offset.set(offset.x, offset.y);
		}

		if (rotation !== undefined) {
			newTexture.rotation = rotation;
		}

		acc[key] = newTexture; // Store texture in object
		return acc;
	}, {});
}
